import UXCGModal from './UXCGModal';

export default UXCGModal;
